import React, { useRef } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import { ImageMedia } from '../imports';
import useRouting from '../../hooks/useRouting';
import useMouse from '../../hooks/useMouse';
import useWindowSize from '../../hooks/useWindowSize';
import { motion /* , useScroll  */} from 'framer-motion';
import animA from '../../animations/animA';


const Footer = () => {

  const pathname = useLocation().pathname;
  const paths = ['/404', "/contact"];
  const condition = paths.includes(pathname);
  const hideFooter = condition;

  const { onMobile } = useWindowSize();
  const { footerlinks, footerExtra } = useRouting();
  const footerRef = useRef(null);

  // const cta = <h1 className='whitespace-nowrap w-[50vw]'>Let&apos;s talk&nbsp;•&nbsp;</h1>

  const { toPointer, toDefault } = useMouse();


  const servicesStatus = { show: true, status: true };

  const page = useLocation().pathname;
  const footerThemeCondition = page.includes("/work")

  const navInactive = `${footerThemeCondition ? "" : "relative lg:group-hover:dim= dim quick hover:unmute "} *:!text-[22px] *:!font-light flex items-center`;
  const navActive = navInactive + ` !unmute !nodim`;

  const DeskMotion = motion.div; /* onMobile ? "div" :  */


 /*  const { scrollYProgress } = useScroll({
    target: footerRef,
    offset: ["start end", "end end"]
  }); */


  // const { H } = useWindowSize();
  const { ease, duration } = animA();
  // const top = useTransform(scrollYProgress, [0, 1], [onMobile ? H / 2 : H / 5, 0]);

  return (
    <footer ref={footerRef} className={twMerge(
      'relative w-full lg:min-h-[50vh] h-[100vh]= ==h-fit overflow-clip flex flex-col justify-end items-start', footerThemeCondition ? "bg-slate-200 text-black" : "bg-gradient-to-t from-black to-dark",
      hideFooter && "!hidden")}>

      <DeskMotion style={{ /* top */ }} transition={{ ease, duration }} className='lg:absolute= lg:inset-0= bottom-0 origin-bottom flex flex-col w-full relative z-[2]'>
        <div className='resp flex flex-col gap-8 paddingY'>

          {/*  <div className='Logo&Title space-y-4'>
            <Logo />
            <h4 className='dim muted'>Expertise 36O° en affaires de Marque.</h4>
          </div>  */}

          <div className='flex flex-col lg:flex-row mt-8 gap-8 '>

            {/* MAIN LINKS */}
            <div id="mainLinks" className='flex flex-col w-full space-y-2 '>
              <h5 className='muted dim capitalize font-light noaction'>{footerlinks[0].section}</h5>
              <ul className='space-y-1'>
                {footerlinks[0].links.map((link, j) => {
                  return (
                    <li id={footerThemeCondition ? 'buttonUnderlineW' : "buttonUnderline"} /* onMouseEnter={toPointer} onMouseLeave={toDefault} */ key={link.label} className='relative flex w-fit space-x-2'>
                      <NavLink to={link.href ? link.href : "#"} className={({ isActive }) => isActive ? twMerge(navActive, "!opacity-100 !brightness-100") : twMerge(navInactive, "!opacity-80 !brightness-100")}>
                        <p className='capitalize font-light'>{link.label} </p>
                      </NavLink>
                      {/* {link.hint && <h5 className='opacity-20 text-gray-500 text-select-none pointer-events-none'>/{link.hint}</h5>} */}
                    </li>
                  )
                })}
              </ul>
            </div>

            {/* OTHER LINKS */}
            <div id="otherLinks" className='flex flex-col w-full space-y-8'>

              <div id="contacts" className='space-y-2'>
                <h5 className='muted dim capitalize font-light noaction'>{footerlinks[1].section}</h5>
                <ul className='space-y-1'>
                  {footerlinks[1].links.map((link, j) => {
                    return (
                      <li
                        key={link.label}
                        id={footerThemeCondition ? 'buttonUnderlineW' : "buttonUnderline"}
                        className='w-fit relative'
                      >
                        <NavLink to={link.href ? link.href : "#"} className={({ isActive }) => isActive ? twMerge(navActive, "!opacity-100 !brightness-100") : twMerge(navInactive, "!opacity-100 !brightness-100")}>
                          <p className='capitalize font-light'>{link.label}</p>&nbsp;:&nbsp;
                          <p className='font-light dim group-hover:nodim'>{link.value && link.value}</p>
                        </NavLink>
                      </li>
                    )
                  })}
                </ul>
              </div>

              <div id="follow" className='space-y-2'>
                <h5 className='muted dim capitalize font-light noaction'>{footerlinks[2].section}</h5>
                <ul className='flex gap-4 '>
                  {footerlinks[2].links.map((link, j) => {
                    return (
                      <li
                        key={link.label}
                        id={footerThemeCondition ? 'buttonUnderlineW' : "buttonUnderline"}
                        onMouseEnter={toPointer}
                        onMouseLeave={toDefault}
                        className='flex items-center relative !w-fit'
                      >
                        <NavLink
                          to={link.href ? link.href : "#"}
                          target='_blank'
                          className={({ isActive }) => !isActive && `${navInactive} nodim unmute flex items-center `}
                        >
                          <p className='DESK capitalize leading-none !font-light py-1'>{link.label}</p>
                          <span className='flex size-12 lg:size-5 center max-sm:border border1 max-sm:rounded-lg  relative ml-1'>
                            <i className={`${onMobile ? "ri-xl" : "ri-sm"}  dim ri-${link.icon}-fill`} />
                          </span>
                        </NavLink>
                      </li>
                    )
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* BOTTOM */}
        <div className='block py-6 lg:py-10 max-md:pb-24 border-t border1'>
          <div className='flex items-center resp'>
            <div className='*:w-full flex flex-col max-lg:flex-col-reverse lg:flex-row justify-between w-full gap-8 '>
              {servicesStatus.show &&
                <div>
                  <div className='!size-8 !inline-flex center !nodim !unmute'>
                    <ImageMedia src={require('../../assets/branding/LAWWD_Favicon.jpg')} className="p-1 object-contain" title="LAWWD" />
                  </div>
                  <div className='block text-base font-light muted dim hover:!unmute hover:!nodim select-none pointer-events-none *:inline *:items-center *:space-x-3'>
                    {servicesStatus.status ?
                      <span>Tous nos services sont opérationnels<span className='inline-flex center bg-green-400 size-2 rounded-full ml-2' /></span>
                      :
                      <span>Nos services sont momentanément indisponibles<span className='inline-flex center bg-orange-400 size-2 rounded-full ml-2' /></span>
                    }
                  </div>
                </div>
              }
              <div className='w-full flex mt-8'>
                <div className='flexResp w-fit gap-3 *:w-fit *:relative lg:gap-6 group-hover:*:muted group-hover:*:dim *:hover:nodim *:hover:!unmute *:capitalize *:quicker'>
                  <Link id={footerThemeCondition ? 'buttonUnderlineW' : "buttonUnderline"} to={footerExtra.privacy.link} className={twMerge(navInactive, "text-base !font-light relative !transform-none !normal-case")}>
                    {footerExtra.privacy.title}
                  </Link>
                  <Link id={footerThemeCondition ? 'buttonUnderlineW' : "buttonUnderline"} to={footerExtra.resources.link} className={twMerge(navInactive, "text-base !font-light relative !normal-case")}>
                    {footerExtra.resources.title}
                  </Link>
                  <Link id={footerThemeCondition ? 'buttonUnderlineW' : "buttonUnderline"} to={footerExtra.cookies.link} className={twMerge(navInactive, "text-base !font-light relative !normal-case")}>
                    {footerExtra.cookies.title}
                  </Link>
                </div>
              </div>
            </div>

          </div>
        </div>
      </DeskMotion>

    </footer>
  )
}

export default Footer
